

























































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue } from "vue-property-decorator";
import AuditEtikaBatukService from "@/services/AuditEtikaBatukService";
import AuditEtikaBatukKriteriaLogger from "./AuditEtikaBatukKriteriaLogger.vue";
import AuditEtikaBatukDetail from "./AuditEtikaBatukDetail.vue";
import {
  METODE_AUDIT_OPTIONS,
  RUANG_OPTIONS,
  KATEGORI_OBSERVEE_OPTIONS
} from "@/constants/kriteriaEtikaBatuk";
import UnitRuangPicker, { UnitRuangOption } from "@/components/common/UnitRuangPicker.vue";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";

@Component({
  components: { AuditEtikaBatukKriteriaLogger, AuditEtikaBatukDetail, UnitRuangPicker, PersonAutoComplete }
})
export default class AuditEtikaBatukList extends Vue {
  mode: "list" | "create" | "logger" | "detail" = "list";
  currentSessionId = 0;

  sessions: any[] = [];
  loading = false;
  creating = false;

  filterTglDari = "";
  filterTglSampai = "";
  filterStatus: string | null = null;
  filterKategori: string | null = null;

  metodeOptions = METODE_AUDIT_OPTIONS;
  ruangOptions = RUANG_OPTIONS;
  kategoriOptions = KATEGORI_OBSERVEE_OPTIONS;

  form: any = this.emptyForm();

  statusOptions = [
    { text: "Draft", value: "draft" },
    { text: "TTD Auditor", value: "submitted" },
    { text: "Diperiksa Ketua PPI", value: "verified_ketua_ppi" },
    { text: "Disetujui Ka. Unit", value: "approved_kaunit" },
    { text: "Disetujui Direktur", value: "approved_direktur" },
    { text: "Closed", value: "closed" }
  ];

  bulanOptions = [
    { text: "Januari", value: 1 }, { text: "Februari", value: 2 },
    { text: "Maret", value: 3 }, { text: "April", value: 4 },
    { text: "Mei", value: 5 }, { text: "Juni", value: 6 },
    { text: "Juli", value: 7 }, { text: "Agustus", value: 8 },
    { text: "September", value: 9 }, { text: "Oktober", value: 10 },
    { text: "November", value: 11 }, { text: "Desember", value: 12 }
  ];

  headers = [
    { text: "Nomor", value: "nomor_formulir" },
    { text: "Tanggal", value: "tanggal_audit" },
    { text: "Unit", value: "unit_nama" },
    { text: "Observee", value: "observee" },
    { text: "% Patuh", value: "compliance_rate_total" },
    { text: "Kategori", value: "kategori_kepatuhan" },
    { text: "Status", value: "status" },
    { text: "", value: "actions", sortable: false, width: 120 }
  ];

  emptyForm() {
    return {
      unit_id: "",
      unit_nama: "",
      tanggal_audit: "",
      waktu_mulai: "",
      metode_audit: "observasi_langsung",
      periode_bulan: new Date().getMonth() + 1,
      periode_tahun: new Date().getFullYear(),
      ruang_tipe: [],
      auditor_nama: "",
      auditor_sip_str: "",
      auditor_jabatan: "Komite PPI",
      observee_nama_inisial: "",
      observee_no_rm_nip: "",
      observee_kategori: "pasien",
      observee_kategori_lainnya: "",
      observee_lama_bekerja_dirawat: ""
    };
  }

  get canCreate(): boolean {
    return !!(
      this.form.unit_id &&
      this.form.tanggal_audit &&
      this.form.metode_audit &&
      this.form.periode_bulan &&
      this.form.periode_tahun &&
      this.form.observee_nama_inisial &&
      this.form.observee_kategori
    );
  }

  async mounted() {
    await this.loadData();
  }

  async loadData() {
    this.loading = true;
    try {
      const params: any = {};
      if (this.filterTglDari) params.tgl_dari = this.filterTglDari;
      if (this.filterTglSampai) params.tgl_sampai = this.filterTglSampai;
      if (this.filterStatus) params.status = this.filterStatus;
      if (this.filterKategori) params.observee_kategori = this.filterKategori;
      const res = await AuditEtikaBatukService.getList({ params });
      this.sessions = res.data.data.data || res.data.data;
    } finally {
      this.loading = false;
    }
  }

  openCreate() {
    this.mode = "create";
    this.form = this.emptyForm();
    const today = localISODate();
    this.form.tanggal_audit = today;
    this.form.waktu_mulai = new Date().toTimeString().slice(0, 5);
    this.form.periode_bulan = new Date().getMonth() + 1;
    this.form.periode_tahun = new Date().getFullYear();
  }

  onUnitChange(unit: UnitRuangOption | null) {
    this.form.unit_nama = unit ? unit.nama : "";
  }

  async createSession() {
    if (!this.canCreate) return;
    this.creating = true;
    try {
      const res = await AuditEtikaBatukService.create(this.form);
      const sess = res.data.data;
      this.currentSessionId = sess.id;
      this.mode = "logger";
    } finally {
      this.creating = false;
    }
  }

  openLogger(item: any) {
    this.currentSessionId = item.id;
    this.mode = "logger";
  }

  openDetail(item: any) {
    this.currentSessionId = item.id;
    this.mode = "detail";
  }

  async returnToList() {
    this.mode = "list";
    await this.loadData();
  }

  printPdf(id: number) {
    AuditEtikaBatukService.printPdf(id);
  }

  formatDate(s: string) {
    if (!s) return "-";
    return new Date(s).toLocaleDateString("id-ID");
  }

  kategoriLabel(k: string): string {
    return this.kategoriOptions.find(o => o.value === k)?.text || k;
  }

  getComplianceColor(rate: number) {
    if (!rate && rate !== 0) return "grey";
    if (rate >= 85) return "success";
    if (rate >= 76) return "warning";
    return "error";
  }
}
